import ComingSoon from './containers/ComingSoon';

function App() {
	return (
		<div className='App'>
			<ComingSoon />
		</div>
	);
}

export default App;
